const uuid=value=>typeof value==='string'&&/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)

// No imports or side effects: bootstrap can capture before Auth/telemetry start,
// and repeated StrictMode reads must not consume the invitation.
export function captureSupportInvitation(location) {
  const hash=new URLSearchParams(String(location?.hash||'').replace(/^#/,''))
  const keys=['support_token_hash','support_token_type','support_user_id']
  const tokenHash=hash.get(keys[0]),type=hash.get(keys[1]),userId=hash.get(keys[2])
  if(keys.some(key=>hash.getAll(key).length!==1)||!['invite','recovery'].includes(type)||!uuid(userId)
    ||typeof tokenHash!=='string'||!/^[a-zA-Z0-9_-]{20,512}$/.test(tokenHash)
    ||['access_token','refresh_token','error','error_code'].some(key=>hash.has(key))) return Object.freeze({kind:'invalid'})
  return Object.freeze({kind:'invitation',tokenHash,type,userId})
}

export function cleanSupportInvitationUrl(location,history) {
  const search=new URLSearchParams(String(location?.search||''))
  ;['support_token_hash','support_token_type','support_user_id'].forEach(key=>search.delete(key))
  const query=search.toString()
  history?.replaceState(history.state,'',`${location?.pathname||'/'}${query?`?${query}`:''}`)
}
